import { OrganizationAssistantDestination } from "@simplyk/common";

import { useTranslate } from "@/common/hooks/useTranslate";

export const useDestinationLabels = (): Record<OrganizationAssistantDestination, string> => {
  const { t } = useTranslate();
  return {
    payouts: t("dashboard", "organizationAssistant.navigation.payouts"),
    payout_detail: t("dashboard", "organizationAssistant.navigation.payout_detail"),
    bank: t("dashboard", "organizationAssistant.navigation.bank"),
    bank_settings: t("dashboard", "organizationAssistant.navigation.bank_settings"),
    create_bank_account: t("dashboard", "organizationAssistant.navigation.create_bank_account"),
    stripe_onboarding: t("dashboard", "organizationAssistant.navigation.stripe_onboarding"),
    identity_verification: t("dashboard", "organizationAssistant.navigation.identity_verification"),
    payments: t("dashboard", "organizationAssistant.navigation.payments"),
    payment: t("dashboard", "organizationAssistant.navigation.payment"),
    form_editor: t("dashboard", "organizationAssistant.navigation.form_editor"),
    campaign_hub: t("dashboard", "organizationAssistant.navigation.campaign_hub"),
    campaigns: t("dashboard", "organizationAssistant.navigation.campaigns"),
    team: t("dashboard", "organizationAssistant.navigation.team"),
    invite_member: t("dashboard", "organizationAssistant.navigation.invite_member"),
    tax_receipts: t("dashboard", "organizationAssistant.navigation.tax_receipts"),
    organization_settings: t("dashboard", "organizationAssistant.navigation.organization_settings"),
    organization_information: t("dashboard", "organizationAssistant.navigation.organization_information"),
    organization_page_editor: t("dashboard", "organizationAssistant.navigation.organization_page_editor"),
    communications: t("dashboard", "organizationAssistant.navigation.communications"),
    contacts: t("dashboard", "organizationAssistant.navigation.contacts"),
    insights: t("dashboard", "organizationAssistant.navigation.insights"),
  };
};
